module.exports = __webpack_public_path__ + "static/media/arrow_next.d9381fcc.svg";